import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TemplateBrowser } from '@/components/templates/TemplateBrowser';
import type { TemplateCatalog } from '@/types/template';

const Templates: React.FC = () => {
  const navigate = useNavigate();

  const handleSelect = (template: TemplateCatalog) => {
    navigate(`/sites/new?template_id=${encodeURIComponent(template.id)}`);
  };

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto pt-5 pb-6">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-foreground">Templates</h1>
          <p className="text-sm text-muted-foreground mt-2 max-w-xl">
            Pick one, customize the content, and publish in just a few clicks.
          </p>
        </div>
        <TemplateBrowser onTemplateSelect={handleSelect} />
      </div>
    </div>
  );
};

export default Templates;
